import { render, staticRenderFns } from "./oilCleanlinessMonitoring.vue?vue&type=template&id=72f9e1de&scoped=true"
import script from "./oilCleanlinessMonitoring.vue?vue&type=script&lang=js"
export * from "./oilCleanlinessMonitoring.vue?vue&type=script&lang=js"
import style0 from "./oilCleanlinessMonitoring.vue?vue&type=style&index=0&id=72f9e1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9e1de",
  null
  
)

export default component.exports